'use client'

import { useCallback, useState } from 'react'

import { useDeleteOrderMutation, GetMyInfosDocument } from '@/core/graphql/hooks'

/**
 * Drives the delete-order confirmation flow: tracks which order is pending
 * deletion and runs the deleteOrder mutation (refetching myInfos so any list
 * that renders orders reflects the removal). Shared by the dashboard orders
 * strip and the account orders list.
 */
export function useDeleteOrder() {
  const [deleteOrder] = useDeleteOrderMutation({
    refetchQueries: [{ query: GetMyInfosDocument }],
    awaitRefetchQueries: true,
  })

  const [orderToDelete, setOrderToDelete] = useState<string | null>(null)

  const requestDelete = useCallback((orderId: string) => setOrderToDelete(orderId), [])
  const cancelDelete = useCallback(() => setOrderToDelete(null), [])

  const confirmDelete = useCallback(async () => {
    if (!orderToDelete) return
    try {
      await deleteOrder({ variables: { orderId: orderToDelete } })
      setOrderToDelete(null)
    } catch (error) {
      console.error('Error deleting order:', error)
    }
  }, [deleteOrder, orderToDelete])

  return { orderToDelete, requestDelete, cancelDelete, confirmDelete }
}
